<template>
  <div>
    <b-row style="margin-top: 20px">
      <b-col>
        <p>
          Nodos asociados a
          <span class="selectedTitle">{{ selectedLocation }}</span>
        </p>
        <div class="minGroupBox">
          <!-- Tabla con la lista de nodos-->
          <vue-good-table
            :columns="columnsNodos"
            :rows="rowsNodos"
            styleClass="vgt-table condensed"
            @on-row-click="loadNodeSensors"
            :row-style-class="rowStyleNodos"
            :search-options="{
              enabled: false,
              //trigger: 'enter',
              skipDiacritics: true,
              //searchFn: mySearchFn,
              placeholder: 'Buscar en la tabla',
              //externalQuery: searchQuery
            }"
            :sort-options="{
              enabled: true,
              initialSortBy: { field: 'aliasnodo', type: 'asc' },
            }"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 10,
              dropdownAllowAll: false,
              //setCurrentPage: 2,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: 'Filas por pagina',
              ofLabel: 'de',
              pageLabel: 'pagina', // for 'pages' mode
              allLabel: 'Todas',
            }"
            :isLoading.sync="isLoadingNodo"
          >
            <template slot="loadingContent">
              <table-loading />
            </template>
            <template slot="emptystate">
              <table-empty-state />
            </template>
          </vue-good-table>
        </div>
      </b-col>

      <b-col>
        <p>
          Sensores asociados al nodo
          <span class="selectedTitle">{{ selectedNode }}</span>
        </p>
        <div class="minGroupBox">
          <div
            v-if="selectedNode"
            v-bind:class="[needBlur ? 'enableBlur' : 'disableBlur']"
          >
            <!-- Tabla con la lista de sensores-->
            <vue-good-table
              :columns="columnsSensores"
              :rows="rowsSensores"
              ref="tablaSensores"
              styleClass="vgt-table condensed"
              @on-row-click="openRow"
              :row-style-class="rowStyleSensores"
              :search-options="{
                enabled: false,
                //trigger: 'enter',
                skipDiacritics: true,
                //searchFn: mySearchFn,
                placeholder: 'Buscar en la tabla',
                //externalQuery: searchQuery
              }"
              :sort-options="{
                enabled: true,
                initialSortBy: { field: 'tipologiasensor', type: 'asc' },
              }"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 10,
                dropdownAllowAll: false,
                //setCurrentPage: 2,
                nextLabel: '',
                prevLabel: '',
                rowsPerPageLabel: 'Filas por pagina',
                ofLabel: 'de',
                pageLabel: 'pagina', // for 'pages' mode
                allLabel: 'Todas',
              }"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'acciones'">
                  <span style="margin-right: 10px">
                    <i class="far fa-eye fa-lg" title="Mostrar medidas"></i>
                  </span>
                </span>
              </template>

              <div slot="emptystate" class="text-center">
                Seleccione un nodo de la lista para cargar los datos
              </div>
            </vue-good-table>
          </div>
          <div v-else>
            <p class="unselectedTitle text-center">
              <span
                ><i class="fas fa-exclamation-circle"></i> Seleccione un nodo de
                la lista <i class="fas fa-exclamation-circle"></i
              ></span>
            </p>
            <p class="unselectedMessage">
              <span
                >Podrá visualizar los sensores asociados, las medidas recibidas
                de cada uno de ellos y su evolución temporal</span
              >
            </p>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- MODAL OCULTO CON LA INFORMACION DE LAS MEDIDAS -->
    <b-modal
      id="modal-center"
      centered
      title="BootstrapVue"
      size="xl"
      v-model="showMeasureModal"
      hide-footer
      hide-header
      scrollable
    >
      <!-- titulo modal -->
      <p class="text-center">Medidas del sensor seleccionado</p>
      <hr style="opacity: 0.1 !important" />
      <br />
      <!-- datos modal -->

      <b-row>
        <b-col style="margin-left: 50px; font-size: 13px" cols="4">
          <!---->
          <b-row>
            <b-col class="text-left" cols="4">
              <span><b>Tipologia: </b></span>
            </b-col>
            <b-col class="text-left">
              <span>{{ selectedMeasureModal.tipologiasensor }}</span>
            </b-col>
          </b-row>
          <!---->
          <b-row>
            <b-col class="text-left" cols="4">
              <span><b>Ubicación: </b></span>
            </b-col>
            <b-col class="text-left">
              <span>{{ selectedLocation }}</span>
            </b-col>
          </b-row>
          <!---->
          <b-row>
            <b-col class="text-left" cols="4">
              <span><b>Descripcion: </b></span>
            </b-col>
            <b-col class="text-left">
              <span>{{ selectedMeasureModal.description }}</span>
            </b-col>
          </b-row>
          <!---->
          <b-row>
            <b-col class="text-left" cols="4">
              <span><b>Nodo: </b></span>
            </b-col>
            <b-col class="text-left">
              <span>{{ selectedMeasureModal.nodoasociado }}</span>
            </b-col>
          </b-row>
          <!---->
          <b-row class="mt-4" v-if="isValveSensor">
            <b-col class="text-left" cols="4">
              <span><b>Acciones: </b></span>
            </b-col>
            <b-col class="text-left">
              <button class="btn btn-success me-2" @click="manageValve('open')">Abrir</button>
              <button class="btn btn-danger" @click="manageValve('close')">Cerrar</button>
            </b-col>
          </b-row>
          <!---->
        </b-col>

        <b-col>
          <b-button
            pill
            variant="outline-danger"
            @click="cleanMeasures"
            style="
              zoom: 90%;
              width: 200px !important;
              margin: 5px 10px 5px 10px;
            "
            v-if="isUserAdmin()"
          >
            <i class="far fa-trash-alt"></i>
            <span style="font-size: 13px; padding-left: 10px"
              >Limpiar el historial de medidas</span
            >
          </b-button>

          <b-button
            pill
            variant="outline-primary"
            @click="triggerPDF"
            style="
              zoom: 90%;
              width: 200px !important;
              margin: 5px 10px 5px 10px;
            "
            v-if="isUserAdmin()"
          >
            <i class="fas fa-download"></i>
            <span style="font-size: 13px; padding-left: 10px"
              >Descargar historial en PDF</span
            >
          </b-button>

          <b-button
            pill
            variant="outline-primary"
            @click="triggerCSV"
            style="
              zoom: 90%;
              width: 200px !important;
              margin: 5px 10px 5px 10px;
            "
            v-if="isUserAdmin()"
          >
            <i class="fas fa-download"></i>
            <span
              style="font-size: 13px; padding-left: 10px"
              v-if="isDownloading"
              >Descargando... {{ CSVProgressBar }} Mb</span
            >
            <span style="font-size: 13px; padding-left: 10px" v-else
              >Descargar historial en CSV</span
            >
          </b-button>
        </b-col>
      </b-row>

      <b-tabs fill style="margin-top: 40px">
        <b-tab title="Datos" class="borderTab">
          <div>
            <sensor-measures
              ref="measuresComp"
              style="padding: 20px"
              @hook:mounted="loadMeasures"
            ></sensor-measures>
          </div>
        </b-tab>
        <b-tab title="Gráfica" class="borderTab" @click="loadMeasuresChart" v-if="!isValveSensor">
          <sensor-measures-chart
            ref="measuresChartComp"
            style="padding: 20px"
          />
        </b-tab>
      </b-tabs>
    </b-modal>
    <!-- MODAL OCULTO CON LA INFORMACION DE LAS MEDIDAS -->
  </div>
</template>


<script>
// MIRAR EN https://xaksis.github.io/vue-good-table/guide/
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import DeviceService from "@/services/DeviceService";
import SensorService from "@/services/SensorService";
import UserService from "@/services/UserService";
import Constants from "@/Constants";

import SensorMeasures from "@/components/sensors/SensorMeasures";
import SensorMeasuresChart from "@/components/sensors/SensorMeasuresChart";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";

export default {
  name: "device-list",
  props: ["location"],
  components: {
    VueGoodTable,
    "sensor-measures": SensorMeasures,
    "sensor-measures-chart": SensorMeasuresChart,
    "table-loading": TableLoading,
    "table-empty-state": TableEmptyState,
  },
  data() {
    return {
      device: [],
      currentDevice: null,
      currentIndex: -1,
      alias: "",
      showMeasureModal: false,
      selectedMeasureModal: [],
      columnsNodos: [
        {
          label: "UUID",
          field: "uuidnodo",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Tipología nodo",
          field: "tipologianodo",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          hidden: true,
        },
        {
          label: "Alias nodo",
          field: "aliasnodo",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "400",
        },
        {
          label: "SIM",
          field: "simId",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "400",
          hidden: true
        },
        {
          label: "Firmware",
          field: "firmware",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "400",
        },        
        {
          label: "Estado nodo",
          thClass: "text-center",
          tdClass: "text-center",
          field: "estadonodo",
        },
        {
          label: "Sensores",
          thClass: "text-center",
          tdClass: "text-center",
          field: "sensoresnodo",
        },
        {
          label: "Incidencias",
          thClass: "text-center",
          tdClass: "text-center",
          field: "incidenciasnodo",
          hidden: true,
        },
        {
          label: "idnodo",
          field: "idnodo",
          hidden: true,
        },
      ],
      columnsSensores: [
        {
          label: "# id",
          thClass: "text-center",
          tdClass: "text-center",
          field: "id",
          hidden: true,
        },
        {
          field: "tipologiaid",
          hidden: true,
        },
        {
          field: "simId",
          hidden: true,
        },
        {
          label: "Descripcion",
          field: "description",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "15%",
        },
        {
          label: "Tipo sensor",
          field: "tipologiasensor",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
        },
        {
          label: "Última medida",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaultimamedida",
        },
        {
          label: "Incidencias",
          thClass: "text-center",
          tdClass: "text-center",
          field: "incidenciassensor",
          hidden: true,
        },
        {
          label: "Acciones",
          thClass: "text-center",
          tdClass: "text-center",
          field: "acciones",
        },
      ],
      rowsNodos: [],
      rowsSensores: [],
      idtemporal: null,
      needBlur: false,
      selectedNode: null,
      selectedLocation: null,
      selectedNodeId: -1,
      selectedSensorID: -1,
      selectedSensorTypeID: -1,
      isLoadingNodo: false,
      isDownloading: false,
      CSVProgressBar: 0,
    };
  },
  computed: {
    isValveSensor: function(){
      return Constants.ID_SENSOR_TYPES.VALVESENSOR.toString() == this.selectedSensorTypeID;
    }
  },
  mounted() {
    this.getNodesSensorData(this.location);
  },
  methods: {
    getNodesSensorData(location) {
      this.isLoadingNodo = true;
      DeviceService.getDevicesFromLocation(location._id)
        .then((response) => {
          this.refreshNodesSensor(location, response.data);
          this.isLoadingNodo = false;
        })
        .catch((e) => {
          this.isLoadingNodo = false;
          console.log(e);
        });
    },

    refreshNodesSensor(location, nodes) {
      try {
        this.device = nodes;
        this.selectedLocation = location.alias;
        //Cuidado esto puede cortar el lleado del array en caso de que no exista algún campo
        this.populateRowsNodos();
        //Nedd to be cleared here. asi nos aseguramos que se borra aunque falle lo demas
        this.rowsSensores = [];
        this.retrieveSensor(location.device, location.alias);
      } catch (e) {
        console.log(e);
      }
    },

    cleanMeasures() {
      SensorService.deleteMeasures(this.idtemporal)
        .then((response) => {
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: response.data.message
              ? response.data.message
              : "Medidas eliminadas correctamente",
            text: response.data.message
              ? "Se ha(n) eliminado " + response.data.count + " medida(s)"
              : "",
            duration: 3000,
            speed: 1000,
          });
        })
        .catch((e) => {
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error eliminando medidas",
            text: "",
            duration: 3000,
            speed: 1000,
          });
          console.log(e);
        });
    },

    updateProgressbar() {
      this.CSVProgressBar = sessionStorage.getItem("CSVProgressbar");
    },

    triggerPDF() {
      this.$refs.measuresComp.exportPDF(this.idtemporal);
    },

    triggerCSV() {
      if (!this.isDownloading) {
        this.isDownloading = true;
        let refreshIntervalId = setInterval(this.updateProgressbar, 100);
        this.$refs.measuresComp.exportCSV(this.idtemporal).then(() => {
          this.isDownloading = false;
          clearInterval(refreshIntervalId);
        });
      }
    },

    retrieveSensor(nodeid, nodealias) {
      if (nodeid) {
        SensorService.getSensorsFromDevice(nodeid)
          .then((response) => {
            this.sensor = response.data;
            this.selectedNode = nodealias;

            //Cuidado esto puede cortar el lleado del array
            //en caso de que no exista algún campo
            this.populateRowsSensores();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    getImgUrl(image) {
      return require("@/assets/pdf/azvi-sic4/" + image);
    },

    populateRowsNodos() {
      //Create struct before insert it
      this.rowsNodos = [];
      let newData = null;
      let nSensor = 0;

      //Add to array
      for (let i = 0; i < this.device.length; i++) {
        nSensor = 0;
        DeviceService.getSensorCount(this.device[i]._id)
          .then((response) => {
            nSensor = response.data;

            // Fill the struct
            newData = {
              uuidnodo: this.device[i].uuid,
              aliasnodo: this.device[i].alias,
              tipologianodo: this.device[i].type,
              zipnodo: this.device[i].location.zip,
              simId: this.device[i].simId,
              provincianodo: this.device[i].location.province,
              latitudnodo: this.device[i].location.latitude,
              longitudnodo: this.device[i].location.longitude,
              locationnodo: this.device[i].location
                ? this.device[i].location.alias
                : "No asociado",
              firmware: this.device[i].firmware && this.device[i].firmware.version ? this.device[i].firmware.version : "-",
              estadonodo: this.device[i].status ? "Activo" : "Inactivo",
              sensoresnodo: nSensor ? nSensor : 0,
              incidenciasnodo: -1,
              fechaactualizacionnodo: this.$moment(
                String(this.device[i].updatedAt)
              ).format("DD/MM/YYYY HH:mm:ss"),
              idnodo: this.device[i]._id,
              /*Be carefull -> inverted quote to multiple html lines -> Now as slot*/
              /*acciones: ''*/
            };
            //Push the data to the array
            this.rowsNodos.push(newData);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    async populateRowsSensores() {
      //Purge rows
      this.rowsSensores = [];

      //Create struct before insert it
      let newData = null;

      //Add to array List (Fast load)
      for await (let sensor of this.sensor) {
        //Fill the struct
        newData = {
          id: sensor._id,
          tipologiaid: sensor.type._id,
          description: sensor.description,
          tipologiasensor: sensor.type ? sensor.type.alias : "-",
          //estadonodo: this.device[i].status ? "Activo" : "Inactivo",
          sensoresnodo: -1,
          nodoasociado: sensor.device ? sensor.device.alias : "No asociado",
          locationasociado: sensor.device
            ? sensor.device.location
              ? sensor.device.location.alias
              : "No asociado"
            : "No asociado",
          incidenciassensor: -1,
          fechaultimamedida:  "Solicitando",
          fechaactualizacionsensor: "-",
        };
        // Add to array
        this.rowsSensores.push(newData);
      }

      //BLUR OFF
      this.needBlur = false;

      // Now get last measure from each component
      for (let i = 0; i < this.rowsSensores.length; i++) {
        console.log("Solicitando ultima medida del sensor: ", this.rowsSensores[i].id);
        SensorService.getLastMeasure(this.rowsSensores[i].id)
          .then(async (response) => {
            
            if (response.data.length > 0) {
                this.rowsSensores[i].fechaultimamedida = this.$moment(
                  response.data[0].raw_ts
                ).format("DD/MM/YYYY HH:mm:ss");
              } else {
                this.rowsSensores[i].fechaultimamedida = "Sin medida";
              }
          })
          .catch((e) => {
            console.log(e);
          });
      }


    },
    openRow(params) {
      //Save selected Row
      this.selectedSensorTypeID = params.row.tipologiaid;
      this.selectedSensorID = params.row.id;
      this.showMeasureModal = true;
      this.selectedMeasureModal = params.row;
      this.idtemporal = params.row.id;
    },

    loadMeasures() {
      this.$refs.measuresComp.retrieveDataFromSensor(this.idtemporal);
    },

    loadMeasuresChart() {
      this.$refs.measuresChartComp.createChart(
        this.selectedMeasureModal.id,
        this.selectedMeasureModal.tipologiaid
      );
    },

    loadNodeSensors(params) {
      //Save selected Row
      this.selectedNodeId = params.row.idnodo;
      //BLUR delay
      this.needBlur = true;
      //Empty the previous list
      this.rowsSensores = [];
      //Load Sensors rows
      this.retrieveSensor(params.row.idnodo, params.row.aliasnodo);
      //
      //Delay concucrrente de 2 segs
      /*setTimeout(() => {
        //Avisamos al parent de que cambie componente
        this.needBlur = false;
      }, 400);*/
    },

    rowStyleNodos(row) {
      return row.idnodo == this.selectedNodeId ? "selectedTableRow" : "";
    },

    rowStyleSensores(row) {
      return row.id == this.selectedSensorID ? "selectedTableRow" : "";
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },
    manageValve(action){
      SensorService.sendValveCommand(this.selectedSensorID,action).then((response) => {
          //Mensaje de exito
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: response.data.message,
            text: "",
            duration: 3000,
            speed: 1000,
          });
        })
        .catch((e) => {
          console.log(e);
          //Mensaje de error
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "",
            text: response.data.message,
            duration: 3000,
            speed: 1000,
          });
        });
    }
  },
};
</script>


<style scoped>
#html-table {
  display: none;
}

.enableBlur > * {
  filter: blur(3px);
}

.disableBlur {
  filter: blur(0);
}

.minGroupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
  min-height: 210px;
}
.innergroupBox {
  width: 44.3%;
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
  margin-bottom: 15px;
}

.selectedTitle {
  font-style: italic;
  font-weight: 400;
}

p {
  padding-left: 10px;
}
.unselectedMessage {
  font-size: 0.85rem;
  text-align: center;
  padding: 20px 50px 20px 50px;
}

.unselectedTitle {
  padding-top: 20px;
}

.borderTab {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
}
</style>

<style>
.modal .modal-huge {
  max-width: 70%;
  width: 70%;
}

.selectedTableRow {
  background-color: #f1f5fd;
}

.enableBlur {
  filter: blur(5px); /* Ajusta el valor según sea necesario */
}

.disableBlur {
  filter: none;
}

</style>